import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  Inject,
} from '@angular/core';
import { CSPaymentsService } from '../shared-core/services/cspayments.service';
import { IndividualConfig, ModalContainerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { CheckoutType, PayerAuthService } from '../shared-core/services/payer-auth.service';
import {
    CheckEnrollAndAuthorizeRequest,
    ConsumerOrderDetails,
    CreditCard,
    PayerAuthSetup,
    PayerAuthSetupResponse,
    PaymentAuthorizationRequest,
    PaymentAuthorizationResponse, toCreditCardForRequest,
    ValidatePayerAuth
} from "src/app/shared-core/models/payer-auth.model";
import {
  CSPaymentsCheckoutView,
} from 'src/app/shared-core/models/web-payment.model';
import { DOCUMENT } from '@angular/common';
import { Observable, of } from 'rxjs';
import { AppConfigService } from 'src/app/shared-core/services/app-config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { CreditCardFormComponent } from '../shared/credit-card-form/credit-card-form.component';
import { PaymentType } from "../shared-core/models/checkout-data.model";

enum ProcessingState {
  InitialLoading,
  UserInput,
  ProcessingAuthorization,
  AuthorizationReceived,
  ChallengeReceived,
  ChallengeAccepted,
}
@Component({
  selector: 'app-cspayments',
  templateUrl: './cspayments.component.html',
  styleUrls: ['./cspayments.component.scss'],
})
export class CSPaymentsComponent implements OnInit {
  public instructionsControl = new FormControl('');

  @ViewChild('creditCardFormComponent')
  public creditCardComponent: CreditCardFormComponent;

  ProcessingState = ProcessingState;
  _state = ProcessingState.InitialLoading;
  set state(val: ProcessingState) {
    this._state = val;
    setTimeout(() => {
      if (this._state === ProcessingState.ChallengeReceived) {
        this.stepUpModal.show();
      } else if (this.stepUpModal?.isShown) {
        this.stepUpModal.hide();
      }
    });
  }
  get state(): ProcessingState {
    return this._state;
  }
  payerAuthSetupResponse: PayerAuthSetupResponse;
  vistekUrl: string;
  origin = window.location.href;
  Model: CSPaymentsCheckoutView;
  webpaymnentLoadedEvent = 'WebpaymnentLoaded';
  showAmexNotAllowedErrorMessage: boolean = false;

  authResultUrl: string;
  @Input() orderNumber: string;

  @ViewChild('authResultForm', { static: false })
  authResultForm: ElementRef<HTMLFormElement>;
  @ViewChild('stepUpModal') stepUpModal: ModalDirective;
  @ViewChild('frame', { static: true }) frame: ModalContainerComponent;
  @ViewChild('ddcForm', { static: false }) ddcForm: ElementRef<HTMLFormElement>;
  @ViewChild('stepUpForm', { static: false }) stepUpForm: ElementRef<HTMLFormElement>;

  creditCard: CreditCard;
  authorizationResponse: PaymentAuthorizationResponse;
  authorizationRequest: PaymentAuthorizationRequest;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private paymentService: CSPaymentsService,
    private payerAuthService: PayerAuthService,
    private appConfigService: AppConfigService,
    private toaster: ToastService
  ) {
    this.vistekUrl = this.appConfigService.vistekUrl;
  }

  ngOnInit(): void {
    this.orderNumber = (this.document.getElementById('orderNumber') as HTMLInputElement).value;
    this.refreshCSPayments(this.orderNumber);
  }

  public refreshCSPayments(orderNumber: string): void {
    const paymentData = {
      order: orderNumber,
      h: '',
      message: '',
    };
    let payment$: Observable<CSPaymentsCheckoutView>;
    if ((window as any).payment) {
      payment$ = of((window as any).payment as CSPaymentsCheckoutView);
    } else {
      payment$ = this.paymentService.getCSWebPayment(paymentData);
    }
    payment$.subscribe(
      (data) => {
        this.Model = data;
        this.state = ProcessingState.UserInput;
      },
      (error) => {
        this.handleHttpError(error);
      }
    );
  }

  public payPalPayments(): void {
    const paymentData = {
      order: this.Model?.Order?.SalesOrderID,
      h: '',
      message: '',
    };
    this.paymentService.sendPayPalAuthorizePayment(paymentData).subscribe((data) => {
      this.Model = data;
    });
  }

  isInProgress(): boolean {
    return (
      this.state === ProcessingState.ProcessingAuthorization ||
      this.state === ProcessingState.ChallengeReceived ||
      this.state === ProcessingState.AuthorizationReceived
    );
  }

  public onRefreshModalChanged(): void {
    this.frame.hide();
    this.refreshCSPayments(this.orderNumber);
  }

  public onPaymantChanged(typeOfPayment): void {
    this.Model.Payments.PaymentType = typeOfPayment;
    if (typeOfPayment === 'Paypal' && this.Model.RedirectUrl == null) {
      const paymentData = {
        order: this.Model?.Order?.SalesOrderID,
        h: '',
        message: '',
      };
      this.paymentService.sendPayPalAuthorizePayment(paymentData).subscribe((data) => {
        this.Model = data;
      });
    }
  }

  public getImage(id): string {
    for (let i = 0; i < this.Model.OrderDetailContent?.length; i++) {
      if (this.Model.OrderDetailContent[i].Webcode === id) {
        const nameImg = this.Model.OrderDetailContent[i].ImageDataburst?.replace('[', '').replace(']', '').split(',');
        if (nameImg != null) {
          const clearName = nameImg[0].replace('"', '').replace('"', '');
          return `https://img.vistek.net${clearName}?tr=w-75,h-75`;
        } else {
          return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
        }
      }
    }

    return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
  }

  @HostListener('window:message', ['$event'])
  onMessage(event): void {
    if (
      event.origin === 'https://centinelapistag.cardinalcommerce.com' ||
      event.origin === 'https://centinelapi.cardinalcommerce.com'
    ) {
      const data = JSON.parse(event.data);

      if (data === undefined || !data.Status) {
        return;
      }
      this.state = ProcessingState.ProcessingAuthorization;
      this.authorizationRequest = this.getAuthorizationRequest();
      this.payerAuthService.authorizePayment(CheckoutType.WebPayment, this.authorizationRequest).subscribe(
        (result) => {
          this.authorizationResponse = result;
          this.processAuthorizationResponse();
        },
        (error) => {
            if (error instanceof HttpErrorResponse && error.status === 422) {
                this.handleValidationErrors(error.error);
            } else {
                this.handleAuthorizationHttpError(error);
            }
        }
      );
    }
    if (event.origin === this.vistekUrl && this.authorizationRequest) {
      let validateResp: ValidatePayerAuth;
      try {
        validateResp = JSON.parse(event.data);
        if (!validateResp.TransactionId) {
          return;
        }
      } catch (error) {
        // this is needed because device fingerprint also posts the same event.origin, but we don't care
        return;
      }
      this.state = ProcessingState.ProcessingAuthorization;
      this.payerAuthService
        .validatePayerAuth(CheckoutType.WebPayment, validateResp.TransactionId, this.authorizationRequest)
        .subscribe(
          (result) => {
            this.authorizationResponse = result;
            this.processAuthorizationResponse();
          },
          (error) => { 
              if (error instanceof HttpErrorResponse && error.status === 422) {
              this.handleValidationErrors(error.error);
          } else {
              this.handleAuthorizationHttpError(error);
          }
          }
        );
    }
  }

  processAuthorizationResponse(): void {
    if (this.authorizationResponse.Approved) {
      this.state = ProcessingState.AuthorizationReceived;
      this.authResultUrl = `${this.vistekUrl}/cart/cspayments/complete`;
      setTimeout(() => {
        this.authResultForm.nativeElement.submit();
      });
    } else {
      if (this.authorizationResponse.Challenge) {
        this.state = ProcessingState.ChallengeReceived;
        setTimeout(() => {
          this.stepUpForm.nativeElement.submit();
        });
      } else {
        this.state = ProcessingState.AuthorizationReceived;
        this.authResultUrl = `${this.vistekUrl}/cart/cspayments/declined`;
        setTimeout(() => {
          this.authResultForm.nativeElement.submit();
        });
      }
    }
  }

  handleHttpError(error: Error): void {
    let message = 'Your payment cannot be processed due to an error on our side. Please contact Customer Support...';
    this.state = ProcessingState.UserInput;
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        message =
          'We have not received a response from the server in a timely manner, this may have been caused by a network delay. Please try again.';
      }
    }
    setTimeout(() => {
      this.toaster.error(message);
    });
  }

  handleAuthorizationHttpError(error: Error): void {
    let message = 'Your payment cannot be processed due to an error on our side. Please contact Customer Support...';
    this.state = ProcessingState.UserInput;
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        message =
          'We have not received a response from the server in a timely manner, but your payment may have been processed.\n Please contact Customer Support... ';
      }
      if (error.status === 404 && error.error === 'OrderNotFound') {
        message = 'Your order is not found or already processed';
        this.Model = null;
      }
    }
    setTimeout(() => {
      this.toaster.error(message);
    });
  }

    handleValidationErrors(validationErrors: any): void {
        let message = '';
        if (Array.isArray(validationErrors.Errors) && validationErrors.Errors.length > 0) {
            // Join all validation error messages into a single string
            message = validationErrors.Errors.join('\n');
        }
        setTimeout(() => {
            this.toaster.error(message);
        });
    }

  handlePayerAuthSetupResponseReject(resp: PayerAuthSetupResponse) {
    this.state = ProcessingState.UserInput;
    setTimeout(() => {
      const config: IndividualConfig = {
        timeOut: 60000,
        extendedTimeOut: 60000,
        positionClass: 'md-toast-top-full-width',
        progressBar: true,
        toastClass: 'my-toast',
        enableHtml: true,
      };
      this.toaster.error(resp.rejectReasonDescription.replace('|', '<br/><br/>'), null, config);
    });
  }

  public completePurchase(): void {
    if (!this.creditCardComponent.isValid()) {
      return;
    }

    this.creditCard = this.creditCardComponent.getCreditCard();

    const model: PayerAuthSetup = {
      cardNumberHidden: btoa(this.creditCard.accountNumber),
      cardholderName: this.creditCard.nameOnAccount,
      expirationMonth: this.creditCard.expirationMonth,
      expirationYear: this.creditCard.expirationYear,
      invoiceNumber: this.Model.Order.NavSalesNumber,
      orderId: this.Model.Order.OrderID,
      orderDetails: this.getOrderDetails()
    };

    this.state = ProcessingState.ProcessingAuthorization;
    (window as any).LogRocket?.track('setupPayerAuthStarts', {
      email: this.Model.Order.Email,
      billingName: this.Model.Order.CustomerName,
      shippingName: this.Model.Order.ShippingName,
      navSalesId: this.Model.Order.NavSalesNumber,
      navDocumentNo: this.Model.Order.SalesOrderID,
      cardholderName: model.cardholderName,
    });

    this.toaster.clear();

    this.payerAuthService.setupPayerAuth(CheckoutType.WebPayment, model).subscribe(
      (result) => {
        if (result.decision == 'REJECT') {
          this.handlePayerAuthSetupResponseReject(result);
          return;
        }
        this.payerAuthSetupResponse = result;
        setTimeout(() => {
          this.ddcForm.nativeElement.submit();
        });
      },
      (error) => {
          if (error instanceof HttpErrorResponse && error.status === 422) {
              this.handleValidationErrors(error.error);
          } else {
              this.handleAuthorizationHttpError(error);
          }
      }
    );
  }

  getOrderDetails(): ConsumerOrderDetails {
    return {
      SalesOrderId: this.Model.Order.SalesOrderID,
      OrderNumber: this.Model.Payments.orderNumber,
      Amount: this.Model.Order.BalanceDue,
      CustomerComments: this.instructionsControl.value,
      AcceptedTerms: false,
      AcceptedDropshipTerms: false,
      Enews: false,
    };
  }

  getAuthorizationRequest(): CheckEnrollAndAuthorizeRequest {
    const authorizationRequest: CheckEnrollAndAuthorizeRequest = {
      ConsumerAuthReferenceId: this.payerAuthSetupResponse.referenceId,
      TransactionMode: this.Model.Payments.TransactionMode,
      Account: toCreditCardForRequest(this.creditCard),
      OrderDetails: this.getOrderDetails(),
      BrowserScreenHeight: window.screen.height.toString(),
      BrowserScreenWidth: window.screen.width.toString(),
      ShouldCreateNetworkToken: false,
      InstrumentIdentifierId: this.creditCard.tokenId
    };
    return authorizationRequest;
  }

  onStepUpClosed() {
    if (this.state === ProcessingState.ChallengeReceived) {
      this.state = ProcessingState.UserInput;
    }
  }

    onValidCardDetected(event: { cardType: string }) {
        if(!this.Model.CanUseAmexForOnlinePayments){
            this.showAmexNotAllowedErrorMessage = event.cardType === 'american-express';
        }

    }
}
